import { notification } from 'antd'
import { Form } from 'formsy-semantic-ui-react'
import React, { Component } from 'react'
import { Button, Label } from 'semantic-ui-react'
import { postResetPassword } from '../api/async/users/index'

class ResetPassword extends Component {
  componentDidMount = async () => {
    document.title = 'Run24Hrs - ลืมรหัสผ่าน'
  }
  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  handleSubmit = () => {
    postResetPassword(this.state.email.toLowerCase()).then(res =>
      notification.success({ message: 'โปรดเช็คอีเมลของท่านเพื่อดำเนินการต่อ' })
    )
  }

  render() {
    const errorLabel = <Label color="red" pointing />
    return (
      <React.Fragment>
        <h1>ลืมรหัสผ่าน</h1>
        <Form
          style={{ marginBottom: '10px' }}
          onValidSubmit={this.handleSubmit}
        >
          <Form.Group>
            <Form.Input
              required
              validations="isEmail"
              validationErrors={{
                isDefaultRequiredValue: 'โปรดกรอกอีเมล',
                isEmail: 'โปรดกรอกอีเมลที่ถูกต้อง'
              }}
              name="email"
              placeholder="โปรดกรอกอีเมล"
              onChange={this.handleChange}
              errorLabel={errorLabel}
            />
          </Form.Group>
          <Button className="ui teal mt10" type="submit">
            รีเซ็ตรหัสผ่าน
          </Button>
        </Form>
      </React.Fragment>
    )
  }
}

export default ResetPassword



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/ResetPassword.js